/* eslint-disable no-unused-vars */
import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { axiosBaseQuery } from '../axios/index';

export const paymentsAPI = createApi({
  reducerPath: 'PaymentsAPI',
  baseQuery: axiosBaseQuery({ baseUrl: '/api/payments' }),
  tagTypes: [],
  endpoints: (build) => ({
    // advertiser saved cards
    GetPaymentsDetails: build.query({
      query: () => {
        return {
          url: '/GetPaymentsDetails',
          method: 'GET',
        };
      },
      providesTags: ['payments/GetPaymentsDetails'],
    }),
    // transactions table
    GetPublisherTransactions: build.query({
      query: (data) => {
        return {
          url: '/GetPublisherTransactions',
          method: 'POST',
          data,
        };
      },
    }),
    // balance and threshold
    GetBalanceDetails: build.query({
      query: (data) => {
        return {
          url: '/GetBalanceDetails',
          method: 'GET',
          data,
        };
      },
    }),
    // default payment type publisher
    GetPaymentType: build.query({
      query: () => {
        return {
          url: '/GetPaymentType',
          method: 'GET',
        };
      },
      providesTags: ['payments/GetPaymentType'],
    }),
    // wire, paypal and default payment type publisher
    GetPublisherPaymentsDetails: build.query({
      query: (data) => {
        return {
          url: '/GetPublisherPaymentsDetails',
          method: 'GET',
          data,
        };
      },
      transformResponse: (response) => {
        return response?.paymentDetails;
      },
      providesTags: ['payments/GetPublisherPaymentsDetails'],
    }),
    // save wire, paypal and default payment type publisher
    SavePayment: build.mutation({
      query: (data) => {
        return {
          url: '/SavePayment',
          method: 'POST',
          data,
        };
      },
      invalidatesTags: ['payments/GetPublisherPaymentsDetails', 'payments/GetPaymentType'],
    }),
    // save only default payment type publisher
    SaveDefaultPaymentType: build.mutation({
      query: (data) => {
        return {
          url: '/SaveDefaultPaymentType',
          method: 'POST',
          data,
        };
      },
      invalidatesTags: ['payments/GetPaymentType'],
    }),
    // add card advertiser
    AddPaymentMethod: build.mutation({
      query: (data) => {
        console.log('card token data');
        console.log(data);
        console.log('card token data');
        return {
          url: '/AddPaymentMethod',
          method: 'POST',
          data,
        };
      },
      invalidatesTags: ['payments/GetPaymentsDetails'],
    }),
  }),
});
